import React from 'react';

import { Switch, Select, Popover } from 'antd';

import styled from 'styled-components';

import { useLayoutContext } from '@contexts/LayoutContext';
import { useStateValue } from '@contexts/StateProvider';

import {
    useContactsSelector,
    useContactsSelectorDispatch,
} from '@components/ContactsSelector/Common/ContactsSelectorContext';
import { ContactsSelectorHeaderWrapper } from '@components/ContactsSelector/Common/ContactsSelectorHeaderUI';
import ModelsAvailability from '@components/ContactsSelector/ModelsSelector/ModelsAvailability/ModelsAvailability';
import ModelFeaturesQuickFilters from '@components/ContactsSelector/ModelsSelector/ModelsWall/ModelsWallHeader/ModelFeaturesQuickFilters';
import MiniLoading from '@components/Gui/MiniLoading';
import { NwButton } from '@components/Gui/NwButton';
import RadioButtonGroup from '@components/Gui/NwForm/RadioButtonGroup';
import { useMailingListContext } from '@components/MailingLists/MailingListContext';

import { useShowSeasonContext } from '@containers/Booking/ShowSeasons/ShowSeasonContext';

import { byPrefixAndName } from '@awesome.me/kit-d6dae216cd/icons';

const QuickFiltersContainer = styled.div`
    margin: 0;
    padding: 0;
    position: relative;
    background: #fff;
    border-radius: 6px;
    border: 1px solid #f0f0f0;
`;

const ModelsWallHeader = ({ beforeChangeSort, filteredList, isLoading, modelList }) => {
    const [{ areaContext }] = useStateValue();

    const layoutContext = useLayoutContext();
    const { isMobile, breakpoints } = layoutContext;

    const nItems = filteredList ? filteredList.length : 0;
    const { additional, layout, selection, actions, context } = useContactsSelector();
    const { listType, quickFilters } = selection;
    const { multipleSelection, multipleSelectionActive } = actions;
    const { enableShowOnlyModelsWithBooks, showOnlyModelsWithBooks, enableModelAvailability } = additional;
    const { view } = layout;
    const { scope } = context;

    const { onAddAllContacts, addingAllContacts } = useMailingListContext();
    const { onAddAllModels, addingAllModels } = useShowSeasonContext();

    const cs_dispatch = useContactsSelectorDispatch();

    const onChangeListSort = (key) => {
        beforeChangeSort();
        cs_dispatch({
            type: 'ChangeQuickFilters',
            quickFilters: { ...quickFilters, sort: key },
        });
    };

    const onChangeListSortFolder = (key) => {
        beforeChangeSort();
        cs_dispatch({
            type: 'ChangeQuickFilters',
            quickFilters: { ...quickFilters, sortFolder: key },
        });
    };

    const toggleMultipleSelection = (value) => {
        cs_dispatch({
            type: 'ToggleMultipleSelection',
            value: value,
        });
    };

    let sortOptionsFolder = [
        { label: 'Name', value: 'Name' },
        { label: 'Manual', value: 'Manual' },
    ];
    let sortOptions = [
        { label: 'Name', value: 'Name' },
        { label: 'ID', value: 'ID' },
        { label: 'Mother Agency', value: 'MotherAgency' },
    ];

    const handleChangeView = (selectedView) => {
        cs_dispatch({
            type: 'ChangeView',
            view: selectedView,
            area: areaContext.area,
        });
    };

    const handleAddAllContactsToMailingList = async () => {
        onAddAllContacts(filteredList.map((model) => model.ID));
    };

    const handleAddAllModelsToSeason = async () => {
        onAddAllModels(filteredList.map((model) => model.ID));
    };

    const hiddenModels = modelList ? modelList.filter((model) => !model.ST) : [];

    return (
        <ContactsSelectorHeaderWrapper>
            <div className="styled-header-wrapper">
                {isMobile ? (
                    !isLoading ? (
                        !quickFilters.globalNameFilter && (
                            <div className="mobile-header-availability">
                                {areaContext.area !== 'scouting' &&
                                    scope !== 'accounting-search' &&
                                    enableModelAvailability && <ModelsAvailability models={filteredList} />}
                            </div>
                        )
                    ) : (
                        <div className="loading-container">
                            <MiniLoading />
                        </div>
                    )
                ) : (
                    <div className="styled-header styled-header-top-align">
                        <div className="header-summary">
                            {!isLoading ? (
                                <>
                                    <div className="header-summary-text">
                                        <em className="counter">{nItems}</em> MODELS FOUND
                                    </div>
                                    {hiddenModels.length ? (
                                        <Popover
                                            trigger="click"
                                            placement="bottom"
                                            content={
                                                <>
                                                    {hiddenModels.map((model) => (
                                                        <div key={`hidden-models-${model.ID}`}>{model.N}</div>
                                                    ))}
                                                </>
                                            }
                                        >
                                            <small className="hidden-models nw-link">{`${hiddenModels.length} HIDDEN MODELS`}</small>
                                        </Popover>
                                    ) : (
                                        <small className="hidden-models">&nbsp;</small>
                                    )}
                                    {scope === 'package' && !isMobile && (
                                        <div className="control" style={{ marginRight: '10px' }}>
                                            <span className="label">show as</span>
                                            <RadioButtonGroup
                                                value={view.current}
                                                onChange={handleChangeView}
                                                size="small"
                                                options={[
                                                    { label: 'Cards', value: 'cards', disabled: isMobile },
                                                    { label: 'List', value: 'table' },
                                                ]}
                                            />
                                        </div>
                                    )}
                                </>
                            ) : (
                                <>
                                    <div className="loading-container">
                                        <MiniLoading />
                                    </div>
                                    <p className="loading-title">Fetching Models...</p>
                                </>
                            )}
                        </div>
                        <div className="header-filters">
                            {!view.fixed && !isMobile && scope !== 'package' && (
                                <div className="control" style={{ marginRight: '10px' }}>
                                    <span className="label">show as</span>
                                    <RadioButtonGroup
                                        value={view.current}
                                        onChange={handleChangeView}
                                        size="small"
                                        options={[
                                            { label: 'Cards', value: 'cards', disabled: isMobile },
                                            { label: 'List', value: 'table' },
                                        ]}
                                    />
                                </div>
                            )}
                            {!layout.drawer &&
                                (listType === 'folders' ? (
                                    <div className="control">
                                        <span className="label">sort by</span>
                                        {breakpoints < 5 ? (
                                            <Select
                                                autoComplete="off"
                                                options={sortOptionsFolder}
                                                size="small"
                                                value={quickFilters.sortFolder}
                                                onChange={onChangeListSortFolder}
                                            />
                                        ) : (
                                            <RadioButtonGroup
                                                value={quickFilters.sortFolder}
                                                onChange={onChangeListSortFolder}
                                                size="small"
                                                options={sortOptionsFolder}
                                            />
                                        )}
                                    </div>
                                ) : (
                                    <div className="control">
                                        <span className="label">sort by</span>
                                        {breakpoints < 5 ? (
                                            <Select
                                                autoComplete="off"
                                                options={sortOptions}
                                                size="small"
                                                value={quickFilters.sort}
                                                onChange={onChangeListSort}
                                            />
                                        ) : (
                                            <RadioButtonGroup
                                                value={quickFilters.sort}
                                                onChange={onChangeListSort}
                                                size="small"
                                                options={sortOptions}
                                            />
                                        )}
                                    </div>
                                ))}
                            {enableShowOnlyModelsWithBooks && (
                                <div className="control" style={{ marginRight: '10px' }}>
                                    <Switch
                                        checked={showOnlyModelsWithBooks}
                                        onChange={(value) => {
                                            cs_dispatch({
                                                type: 'ChangeShowOnlyModelsWithBooks',
                                                value: value,
                                            });
                                        }}
                                    />
                                    <span className="label on-right">only models with books</span>
                                </div>
                            )}
                        </div>
                        <div className="header-actions" style={{ flexDirection: layout.drawer && 'column' }}>
                            {multipleSelection && breakpoints !== 1 && (
                                <div className="control" style={{ marginRight: '10px' }}>
                                    <Switch checked={multipleSelectionActive} onChange={toggleMultipleSelection} />
                                    <span className="label on-right">select</span>
                                </div>
                            )}
                            {areaContext.area !== 'scouting' &&
                                scope !== 'accounting-search' &&
                                enableModelAvailability && (
                                    <div className="control">
                                        <ModelsAvailability models={filteredList} />
                                    </div>
                                )}
                            {scope === 'mailing-list' && filteredList.length > 0 && (
                                <div className="control">
                                    <NwButton
                                        primary
                                        loading={addingAllContacts || false}
                                        label="Add all contacts to mailing list"
                                        icon={byPrefixAndName.fasl['plus']}
                                        onClick={handleAddAllContactsToMailingList}
                                    />
                                </div>
                            )}
                            {scope === 'show-season' && filteredList.length > 0 && (
                                <div className="control">
                                    <NwButton
                                        primary
                                        loading={addingAllModels || false}
                                        label="Add all models to season"
                                        icon={byPrefixAndName.fasl['plus']}
                                        onClick={handleAddAllModelsToSeason}
                                    />
                                </div>
                            )}
                        </div>
                    </div>
                )}
            </div>
            {listType === 'all' && quickFilters.showFeaturesQuickFilters && !isMobile && (
                <QuickFiltersContainer>
                    <ModelFeaturesQuickFilters modelList={modelList} />
                </QuickFiltersContainer>
            )}
        </ContactsSelectorHeaderWrapper>
    );
};

export default ModelsWallHeader;
